import { stenaStatisticsBar } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
}

export const TwelveMonthVolumeFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
}) => {
  const { twelveMonthVolume, setTwelveMonthVolume } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setTwelveMonthVolume({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return twelveMonthVolume.from || twelveMonthVolume.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"twelveMonthVolume"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaStatisticsBar}
      children={
        <RangeControl<RangeFilter>
          value={twelveMonthVolume}
          valueFrom={twelveMonthVolume.from}
          valueTo={twelveMonthVolume.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={6}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
